// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: GothamRounded-Medium;
  font-size: 16px;
}

th {
  width: 200px;
  text-align: justify;
  background-color: white;
  padding: 10px;
}

table {
  border-spacing: 0px;
}

.stopRoutePlate_rowContainer_Tz_BC > *:nth-child(odd) {
  background-color: #eaeaea;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopRoutePlate/stopRoutePlate.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  font-family: GothamRounded-Medium;\n  font-size: 16px;\n}\n\nth {\n  width: 200px;\n  text-align: justify;\n  background-color: white;\n  padding: 10px;\n}\n\ntable {\n  border-spacing: 0px;\n}\n\n.rowContainer > *:nth-child(odd) {\n  background-color: #eaeaea;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowContainer": `stopRoutePlate_rowContainer_Tz_BC`
};
module.exports = ___CSS_LOADER_EXPORT___;
